import { render, staticRenderFns } from "./PropertyValue.vue?vue&type=template&id=2ebc2977&scoped=true&lang=pug&"
import script from "./PropertyValue.vue?vue&type=script&lang=js&"
export * from "./PropertyValue.vue?vue&type=script&lang=js&"
import style0 from "./PropertyValue.vue?vue&type=style&index=0&id=2ebc2977&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebc2977",
  null
  
)

/* custom blocks */
import block0 from "./PropertyValue.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports